module.exports = __webpack_public_path__ + "static/coach-scan-ticket-side-ad4d28b175f621482f65d5e0c54bd347.jpg";